
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

const AboutPage = () => {
  const { t, i18n } = useTranslation();

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "About Dava Nasr - Creative Graphic Designer",
    "description": "Learn about Dava Nasr, a creative graphic designer specializing in brand development, graphics, design, illustration, and music playlists",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`,
    "mainEntity": {
      "@type": "Person",
      "name": "Dava Nasr",
      "jobTitle": "Graphic Designer",
      "email": "davagraphiste@gmail.com",
      "description": "Creative graphic designer specializing in brand development, graphics, design, illustration, and music playlists",
      "knowsAbout": ["Brand Development", "Graphics", "Design", "Illustration", "Music Playlists"],
      "hasOccupation": {
        "@type": "Occupation",
        "name": "Graphic Designer",
        "description": "Brand Development • Graphics • Design • Illustration • Music Playlists"
      },
      "image": "https://static.readdy.ai/image/b035185ce40665b0d42a9231037815e9/b97829c9361f7213ea4919c8a43e5496.jpeg"
    }
  };

  return (
    <div className="min-h-screen bg-black">
      <SEOHead
        title="About Dava Nasr - Creative Graphic Designer & Brand Developer"
        description="Learn about Dava Nasr, a creative graphic designer specializing in brand development, graphics, design, illustration, and music playlists. Contact: davagraphiste@gmail.com"
        keywords="Dava Nasr, graphic designer, brand development, creative design, illustration, about designer, contact"
        canonicalUrl={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`}
        schemaData={schemaData}
      />
      
      <Header />

      {/* Hero Section */}
      <section className="py-8 bg-black md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 items-center lg:grid-cols-2 lg:gap-12">
            <div>
              <h1 className="text-3xl font-bold text-white mb-4 md:text-5xl md:mb-6">
                Dava Nasr
              </h1>
              <p className="text-lg text-gray-300 mb-6 md:text-xl md:mb-8">
                {t('aboutSubtitle')}
              </p>
              <div className="text-base text-gray-300 leading-relaxed whitespace-pre-line mb-6 md:text-lg md:mb-8">
                {t('aboutDescription')}
              </div>
              <div className="text-base text-gray-300 leading-relaxed whitespace-pre-line md:text-lg">
                {t('aboutServices')}
              </div>
            </div>

            <div className="relative flex justify-center">
              <img
                src="https://static.readdy.ai/image/b035185ce40665b0d42a9231037815e9/b97829c9361f7213ea4919c8a43e5496.jpeg"
                alt="Dava Nasr - Creative Graphic Designer Portrait"
                title="Dava Nasr - Professional Graphic Designer"
                className="w-60 h-60 object-cover object-center rounded-xl md:w-80 md:h-80"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 md:py-20" style={{ backgroundColor: '#7DC6A0' }}>
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <p className="text-lg text-white/90 mb-6 md:text-xl md:mb-8">
            {i18n.language === 'fr' ? 'Développement de la Marque • Graphismes • Design • Illustration • Playlists Musicales' : 'Brand Development • Graphics • Design • Illustration • Music Playlists'}
          </p>
          <a 
            href="mailto:davagraphiste@gmail.com"
            className="text-lg text-white font-semibold hover:text-white/80 transition-colors duration-200 cursor-pointer md:text-xl"
            title="Contact Dava Nasr - Email"
          >
            davagraphiste@gmail.com
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
